// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Config } from "../config";
import { StoreUserPreferenceArgs } from "./types/rtkQueryTypes";
import { UserPreference } from "./types/userPreferenceTypes";

const apiManagementRootUrl: string | undefined = Config.REACT_APP_CCL_API_MANAGEMENT_URL;

// Define a service using a base URL and expected endpoints
export const cclTokenedUserPreferenceApi = createApi({
    reducerPath: "cclTokenedUserPreferenceApi",
    tagTypes: ["UserPreference", "UserProperties"],
    baseQuery: fetchBaseQuery({
        baseUrl: apiManagementRootUrl,
        prepareHeaders: (headers, { getState }) => {
            //we should probably change this.
            const token = localStorage.getItem("token") as string;
            headers.set("authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        setUserPreference: builder.mutation<UserPreference, Partial<StoreUserPreferenceArgs>>({
            query: (args) => ({
                url: "ccl-access2-data/v1.0/UserPreferences",
                method: "POST",
                body: args,
            }),
            // invalidatesTags: (_, __, args) => [
            //     { type: "UserPreference", id: args.userId },
            //     { type: "UserPreference", id: args.email },
            // ],
        }),
        removeUserPreference: builder.mutation<boolean, Partial<StoreUserPreferenceArgs>>({
            query: (args) => ({
                url: "ccl-access2-data/v1.0/UserPreferences",
                method: "DELETE",
                body: args,
            }),
            // invalidatesTags: (_, __, args) => [
            //     { type: "UserPreference", id: args.userId },
            //     { type: "UserPreference", id: args.email },
            // ],
        }),
        getUserPreferences: builder.query<UserPreference[], string>({
            query: (userid) => `ccl-access2-data/v1.0/UserPreferences/${userid}`,
            providesTags: (_, __, userid) => [{ type: "UserPreference", id: userid }],
        }),
        getUserPreferencesByEmail: builder.query<UserPreference[], string>({
            query: (email) =>
                `ccl-access2-data/v1.0/UserPreferences/by_email/${encodeURIComponent(email)}`,
            providesTags: (_, __, email) => [{ type: "UserPreference", id: email }],
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useSetUserPreferenceMutation,
    useRemoveUserPreferenceMutation,
    useLazyGetUserPreferencesByEmailQuery,
} = cclTokenedUserPreferenceApi;
